import { render, staticRenderFns } from "./addIntegralConfig.vue?vue&type=template&id=5d2ca70d"
import script from "./addIntegralConfig.vue?vue&type=script&lang=js"
export * from "./addIntegralConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports